import { Meta } from '@/components/common';
import { AssignedSeats, LicenceHero, OpenIssues } from '@/components/features/dashboard';
import { Container } from '@/components/layout';
import { useAppSelector } from '@/store/hooks';

/**
 * The customer dashboard, laid out as the design draws it.
 *
 * ── Why licence, seats and downloads live here ──────────────────────────────
 *
 * Because the design puts them here, and it is right to: a lab owner opening
 * this portal has one of three questions - is my licence fine, who is using it,
 * and is anything broken. All three are answerable without a second click.
 *
 * That is why there is no separate Licences page, no Downloads page and no Team
 * page in the design's navigation. Those were pages here, each showing one
 * third of this screen, and each a click away from the question that prompted
 * it.
 *
 * Pages stay thin: set the title, compose feature components. Each component
 * owns its own query and its own loading state, so one slow request does not
 * hold the whole screen blank.
 */
export function DashboardPage() {
  /*
   * The seat roster is the lab owner's view only, as the server also enforces
   * (a non-owner's /licence carries their own seat alone). Everyone else gets
   * the licence card and their issues, full width.
   */
  const isOwner = useAppSelector((state) => state.auth.user?.role === 'owner');

  return (
    <>
      <Meta title="Dashboard" />

      <Container className="space-y-5">
        <LicenceHero />

        {/*
          Two columns at 1fr each, 20px apart - transcribed. Stacked below
          large, because the seat rows and the issue rows both carry a mono
          fingerprint and a pill, and two of those side by side in 400px is
          where the truncation starts.
        */}
        {isOwner ? (
          <div className="grid gap-5 lg:grid-cols-2">
            <AssignedSeats />
            <OpenIssues />
          </div>
        ) : (
          <OpenIssues />
        )}
      </Container>
    </>
  );
}
